import { render, staticRenderFns } from "./Tekst.vue?vue&type=template&id=bc1ebf14&scoped=true&"
import script from "./Tekst.vue?vue&type=script&lang=js&"
export * from "./Tekst.vue?vue&type=script&lang=js&"
import style0 from "./Tekst.vue?vue&type=style&index=0&id=bc1ebf14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ebf14",
  null
  
)

export default component.exports